<template>
  <section :class="option.class">
    <div class="cropper" :style="cropperHeight(30)" v-if="showCroper">
      <app-vue-cropper
        :ref="'cropper1'"
        :img="option.img"
        :outputSize="option.size"
        outputType="png"
        :info="true"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :fixedBox="option.fixedBox"
        :original="option.original"
        :canScale="option.canScale"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
      ></app-vue-cropper>
    </div>

    <div v-if="showCroper" class="alert alert-warning">
      <strong>Recuerda que:</strong>

      <span>
        <strong>1º</strong> Puedes hacer zoom con la rueda del ratón.
      </span>

      <span>
        <strong>2º</strong> Puedes mover la imagen haciendo click con el ratón y moviendola.
      </span>

      <span>
        <strong>3º</strong> Procura que no se vean los recuadros del fondo.
      </span>

      <span>
        <strong>4º</strong> Cuando termines de posicionar la imagen, dale al botón guardar cambios.
      </span>
    </div>
    <div class="options-cropper" :style="(!option.img ? 'width:100%' : false)">
      <div class="buttons">
        <label class="el-button el-button--primary" for="uploads">Buscar imagen</label>
        <input
          id="uploads"
          type="file"
          style="position:absolute; clip:rect(0 0 0 0);"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event, 1)"
        />
        <button
          @click="deleteImage"
          v-if="showPreview && option.img!=null && option.img!=''"
          type="button"
          class="el-button el-button--danger"
        >Borrar Imagen</button>

        <button
          @click="startCrop"
          v-if="showCroper"
          type="button"
          class="el-button el-button--primary"
        >Guardar Cambios</button>
        <!--button
          @click="stopCropCustom"
          v-else
          type="button"
          class="el-button el-button--primary"
        >Deshacer</button-->
        <!--button-- @click="clearCrop" type="button" class="el-button el-button--primary">Limpiar</!--button-->
        <button
          type="button"
          @click="changeScale(1)"
          v-if="showCroper"
          class="el-button el-button--primary"
        >+</button>
        <button
          type="button"
          @click="changeScale(-1)"
          v-if="showCroper"
          class="el-button el-button--primary"
        >-</button>
        <button
          v-if="showCroper"
          @click="rotateLeft()"
          type="button"
          class="el-button el-button--primary"
        >Girar</button>
      </div>
    </div>

    <div
      v-if="showPreview"
      class="show-preview"
      :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}"
    >
      <div :style="cropperHeight(0)" class="transparency">
        <img :src="option.img" />
      </div>
    </div>
  </section>
</template>

<script>
import VueCropper from "vue-cropper";

export default {
  name: "cropper",
  props: ["options"],
  components: {
    "app-vue-cropper": VueCropper
  },
  created() {
    this.options
      ? (this.option = this.options)
      : (this.option = this.optionsDefault);
    setTimeout(() => {
      if (this.option.img) {
        this.showPreview = true;
      }
    }, 500);
  },
  data() {
    return {
      transparency: false,
      showCroper: false,
      showPreview: false,
      show: false,
      crap: false,
      previews: {},
      downImg: "#",
      option: {},
      rotate: null,
      optionsDefault: {
        img: null,
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: false,
        class: "cropper-medium",
        mode: "cover"
      }
    };
  },

  methods: {
    changeScale(num) {
      num = num || 1;
      this.$refs["cropper1"].changeScale(num);
    },
    deleteImage() {
      this.option.img = null;
      this.$root.$emit("imagenEliminada");
    },
    cropperHeight(agregar) {
      return this.options.autoCropHeight
        ? "height:" +
            (parseInt(this.options.autoCropHeight) + agregar) +
            "px;" +
            "width:" +
            this.options.autoCropWidth +
            "px"
        : false;
    },
    getFile(value) {
      return new File([value], "imagen.png", {
        type: "image/png",
        lastModified: Date.now()
      });
    },
    startCrop() {
      this.crap = true;
      this.showCroper = false;
      this.showPreview = true;
      this.$refs["cropper1"].startCrop();
      this.$refs["cropper1"].getCropBlob(data => {
        this.$root.$emit("imagenCargada", this.getFile(data));
      });
      this.$refs["cropper1"].getCropData(data => {
        // do something
        this.option.img = data;
      });
      //  this.$root.$emit("imagenCargada", this.getFile(this.previews.url));
    },
    stopCropCustom() {
      this.crap = false;
      this.showCroper = false;
      this.showPreview = true;

      this.$refs["cropper1"].stopCrop();
      this.$refs["cropper1"].getCropBlob(data => {
        this.$root.$emit("imagenCargada", this.getFile(data));
      });
    },
    clearCrop() {
      this.crap = false;
      this.showCroper = false;
      this.showPreview = true;

      this.$refs["cropper1"].clearCrop();
    },
    realTime(data) {
      // this.previews = data;
    },
    rotateLeft() {
      this.$refs["cropper1"].rotateLeft();

      //this.rotate = this.rotate <= -3 ? 0 : this.rotate - 1;
    },
    rotateRight() {
      this.rotate = this.rotate >= 3 ? 0 : this.rotate + 1;
    },
    uploadImg(e, num) {
      var file = e.target.files[0];
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error({
          type: "ERROR",
          message: "La imagen excede los 10MB y no puede ser cargada!"
        });
        return false;
      }

      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Tipo de archivo aceptado: .gif,jpeg,jpg,png,bmp");
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.option.img = data;
        this.showCroper = true;
        this.showPreview = false;
      };
      reader.readAsArrayBuffer(file);
      // let filedata = { file: this.getFile(file), field: this.f.field };
      // this.$root.$emit("imagenCargada", filedata);
    }
  }
};
</script>

<style lang="scss" scoped>
.div-cropper {
  // min-height: 500px;
}

.cropper {
  // min-height: 500px;
  padding: 15px 0;
  margin-bottom: 25px;
}
.options-cropper {
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-direction: row-reverse;

  height: auto;
  padding: 15px 0;
  margin-bottom: 25px;
}
.show-preview {
  display: block;
}
.preview {
  position: relative;
  height: auto;
  overflow: hidden;
}
.all {
  position: relative;
}
.cropper-medium {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  > .cropper {
    width: 100%;
  }
  > .options-cropper {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-flow: row wrap;
    .buttons {
      width: 100%;
      order: 1;
      text-align: center;
    }
    .show-preview {
      order: 2;
      margin: 0 auto !important;
    }
  }
}
div.transparency {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
}
.alert span {
  display: block;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/commons/cropper.vue